import { Toast } from "vant";

export default {
  install(Vue) {
    // post请求封装
    Vue.prototype.Post = function(data = {}, url, fun) {
      let jd_accessToken = this.Cookies.get("jd_accessToken");
      if (jd_accessToken) {
        data.jd_accessToken = jd_accessToken;
      }
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      this.axios({
        method: "post",
        headers: { Accept: "*/*" },
        url: url,
        data: data
      })
        .then(function(res) {
          toast.clear();
          if (res.data.states) {
            fun(res.data);
          } else {
            Toast.fail("网络请求异常");
          }
        })
        .catch(function(error) {
          toast.clear();
          // console.log(error);
          Toast.fail("服务器请求超时");
        });
    };
    // 保存Storage
    Vue.prototype.saveStringTolocal = function(key, value) {
      if (window.localStorage) {
        localStorage.setItem(key, value);
      }
    };
    // 读取Storage
    Vue.prototype.getStringFromlocal = function(key) {
      if (window.localStorage) {
        return localStorage.getItem(key);
      }
    };
    // 删除Storage
    Vue.prototype.delStringTolocal = function(key) {
      if (window.localStorage) {
        return localStorage.removeItem(key);
      }
    };
    //cookie的设置
    Vue.prototype.setCookie = function(name, value, day) {
      var strCookie = "";
      if (name && value) {
        strCookie = name + "=" + value + ";";
      }
      if (typeof day === "number") {
        var date = new Date();
        date.setDate(date.getDate() + day);
        strCookie += "expires=" + date.toUTCString() + ";";
      }
      return (document.cookie = strCookie);
    };
    //获取cookie
    Vue.prototype.getCookie = function(name) {
      var allcookies = document.cookie;
      //索引长度，开始索引的位置
      var cookie_pos = allcookies.indexOf(name);
      // 如果找到了索引，就代表cookie存在,否则不存在
      if (cookie_pos != -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可
        //计算取cookie值得开始索引，加的1为“=”
        cookie_pos = cookie_pos + name.length + 1;
        //计算取cookie值得结束索引
        var cookie_end = allcookies.indexOf(";", cookie_pos);
        if (cookie_end == -1) {
          cookie_end = allcookies.length;
        }
        //得到想要的cookie的值
        var value = unescape(allcookies.substring(cookie_pos, cookie_end));
      }
      return value;
    };
    //删除cookie
    Vue.prototype.delCookie = function(name) {
      this.setCookie(name, 1, -1);
    };
    // 转化时间戳
    Vue.prototype.stringDate = function(data) {
      if (data == "") {
        return data;
      } else {
        return String(Date.parse(String(data))).substr(0, 10);
      }
    };
    // 时间格式化
    Vue.prototype.format = function(date) {
      function add0(m) {
        return m < 10 ? "0" + m : m;
      }
      if (String(date).length >= 10) {
        let time = new Date(parseInt(date + "000"));
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        let h = time.getHours();
        let mm = time.getMinutes();
        let s = time.getSeconds();
        return (
          y +
          "-" +
          add0(m) +
          "-" +
          add0(d) +
          " " +
          add0(h) +
          ":" +
          add0(mm) +
          ":" +
          add0(s)
        );
      } else {
        return "";
      }
    };
    // 复制
    Vue.prototype.copy = function(code) {
      let save = function(e) {
        e.clipboardData.setData("text/plain", code); //下面会说到clipboardData对象
        e.preventDefault(); //阻止默认行为
      };
      document.addEventListener("copy", save);
      document.execCommand("copy"); //使文档处于可编辑状态，否则无效
      Toast("复制成功");
    };
    // 获取文本中的淘口令
    Vue.prototype.getTaoClick = function(str) {
      return str.match(/[^0-9a-zA-Z]/g, "$");
    };
    // 获取文本中的链接
    Vue.prototype.getUrl = function(str) {
       const urlRegex = '^((https|http|ftp|rtsp|mms)?://)' 
    + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@ 
    + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184 
    + '|' // 允许IP和DOMAIN（域名） 
    + '([0-9a-z_!~*\'()-]+.)*' // 域名- www. 
    + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名 
    + '[a-z]{2,6})' // first level domain- .com or .museum 
    + '(:[0-9]{1,4})?' // 端口- :80 
    + '((/?)|' // a slash isn't required if there is no file name 
    + '(/[0-9a-zA-Z_!~*\'().;?:@&=+$,%#-]+)+/?)$'; 
    const reg = new RegExp(urlRegex); 
      console.log(reg.test(str));
      if (reg.test(str)) {
        return { input: str };
      } 
       const strRegex =
          "^((https|http|ftp|rtsp|mms)?://)" +
          "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + //ftp的user@
          "(([0-9]{1,3}.){3}[0-9]{1,3}" + // IP形式的URL- 199.194.52.184
          "|" + // 允许IP和DOMAIN（域名）
          "([0-9a-z_!~*'()-]+.)*" + // 域名- www.
          "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]." + // 二级域名
          "[a-z]{2,6})" + // first level domain- .com or .museum
          "(:[0-9]{1,4})?" + // 端口- :80
          "((/?)|" + // a slash isn't required if there is no file name
          "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
      const re = new RegExp(strRegex);
      return str.match(re, "$");
    };
    // 判断是否是微信
    Vue.prototype.isWeiXin = function(str) {
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js